function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0967 0L88.2001 3.87121L92.8593 4.51296L89.4893 7.5147L90.2809 11.7792L86.0967 9.77118L81.9124 11.7792L82.704 7.5147L79.334 4.51296L84.0158 3.87121L86.0967 0Z",
  fill: "#2D2D2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M86.1428 6.41751L88.2236 3.87121L86.1428 0V6.41751Z",
  fill: "url(#paint0_linear_584_32340)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0516 0L83.9708 3.87121L86.0516 6.41751V0Z",
  fill: "url(#paint1_linear_584_32340)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0299 6.438L84.0395 3.82959L79.3577 4.45064L86.0299 6.438Z",
  fill: "url(#paint2_linear_584_32340)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M79.334 4.53418L82.704 7.53592L86.0062 6.52154L79.334 4.53418Z",
  fill: "url(#paint3_linear_584_32340)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0297 6.54211L82.7049 7.47369L81.8906 11.7382L86.0297 6.54211Z",
  fill: "url(#paint4_linear_584_32340)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M81.9575 11.7796L86.1418 9.77155L86.0965 6.5835L81.9575 11.7796Z",
  fill: "url(#paint5_linear_584_32340)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M86.12 6.5835L86.0521 9.77155L90.2364 11.7796L86.12 6.5835Z",
  fill: "url(#paint6_linear_584_32340)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M90.3043 11.7382L89.5127 7.47369L86.1879 6.54211L90.3043 11.7382Z",
  fill: "url(#paint7_linear_584_32340)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M86.1879 6.50084L89.49 7.53592L92.8601 4.53418L86.1879 6.50084Z",
  fill: "url(#paint8_linear_584_32340)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M92.8375 4.45064L88.1783 3.82959L86.1653 6.438L92.8375 4.45064Z",
  fill: "url(#paint9_linear_584_32340)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M59.183 9.94667L56.2767 2.00037H58.1279L60.2567 8.11682L62.3669 2.00037H64.218L61.2933 9.94667H59.183Z",
  fill: "#2D2D2D"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M65.0892 2.00037H66.7922V9.94667H65.0892V2.00037Z",
  fill: "#2D2D2D"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M71.6593 2.00067C72.0488 1.9927 72.4361 2.05605 72.7985 2.18698C73.1609 2.31791 73.4911 2.51378 73.7696 2.76311C74.3135 3.27271 74.6179 3.95683 74.6179 4.6692C74.6179 5.38158 74.3135 6.06569 73.7696 6.5753C73.4911 6.82462 73.1609 7.0205 72.7985 7.15143C72.4361 7.28236 72.0488 7.3457 71.6593 7.33774H70.1228V9.94697H68.4384V2.00067H71.6593ZM71.6593 5.88063C71.8294 5.88338 71.9982 5.85309 72.1545 5.79176C72.3109 5.73043 72.4512 5.63945 72.5663 5.52483C72.685 5.40959 72.7773 5.27376 72.8377 5.12535C72.8981 4.97694 72.9254 4.81896 72.9181 4.66073C72.9288 4.34167 72.8026 4.03146 72.5663 3.79664C72.4476 3.68753 72.3061 3.60132 72.1503 3.54312C71.9945 3.48492 71.8276 3.4559 71.6593 3.45777H70.1228V5.88063H71.6593Z",
  fill: "#2D2D2D"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M47.9587 8.68147H46.4467V3.25823H47.9587C49.6581 3.25823 51.0442 4.25356 51.0442 5.99218C51.1088 7.62234 49.7228 8.68147 47.9587 8.68147ZM48.0233 2.03003H45.3159V9.86182H48.0233C50.4142 9.86182 52.3042 8.30822 52.3042 5.94433C52.3042 3.58044 50.3528 2.03003 48.0233 2.03003Z",
  fill: "#2D2D2D"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M0.702039 9.86188H1.90595C1.90423 9.42087 1.9916 8.98388 2.16301 8.57612C2.33442 8.16835 2.5865 7.79786 2.9047 7.48602C3.2229 7.17417 3.60093 6.92714 4.01701 6.75915C4.43309 6.59116 4.87898 6.50554 5.32898 6.50722H5.65436V5.32735H5.32898C4.684 5.32983 4.04661 5.46379 3.45731 5.72072C2.86801 5.97764 2.3397 6.35191 1.90595 6.81973V3.27374H6.13592V2.03009H0.636963L0.702039 9.86188Z",
  fill: "#2D2D2D"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M8.12472 2.03003H6.93787V9.86182H11.7495V8.68147H8.12472V2.03003Z",
  fill: "#2D2D2D"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9183 6.06709C17.9222 6.40316 17.8572 6.73662 17.7269 7.04786C17.5965 7.35911 17.4037 7.64186 17.1595 7.87952C16.9154 8.11717 16.6249 8.30494 16.3051 8.43178C15.9854 8.55861 15.6428 8.62197 15.2976 8.61813C14.9523 8.62197 14.6098 8.55861 14.29 8.43178C13.9703 8.30494 13.6798 8.11717 13.4357 7.87952C13.1915 7.64186 12.9986 7.35911 12.8683 7.04786C12.738 6.73662 12.6729 6.40316 12.6769 6.06709V5.81836C12.6729 5.48229 12.738 5.14884 12.8683 4.8376C12.9986 4.52635 13.1915 4.2436 13.4357 4.00594C13.6798 3.76828 13.9703 3.58052 14.29 3.45368C14.6098 3.32684 14.9523 3.26348 15.2976 3.26733C15.6428 3.26348 15.9854 3.32684 16.3051 3.45368C16.6249 3.58052 16.9154 3.76828 17.1595 4.00594C17.4037 4.2436 17.5965 4.52635 17.7269 4.8376C17.8572 5.14884 17.9222 5.48229 17.9183 5.81836V6.06709ZM15.2976 2.03008C14.7855 2.02754 14.278 2.1239 13.8044 2.31358C13.3309 2.50326 12.9007 2.78249 12.5387 3.13511C12.1768 3.48773 11.8903 3.90673 11.6958 4.36786C11.5014 4.82899 11.4028 5.32309 11.4058 5.82155V6.07028C11.4028 6.56901 11.5015 7.06337 11.6961 7.52471C11.8908 7.98605 12.1776 8.4052 12.5399 8.75786C12.9022 9.11053 13.3328 9.38969 13.8067 9.57918C14.2806 9.76867 14.7885 9.86472 15.3009 9.86176C15.8132 9.86472 16.3211 9.76867 16.795 9.57918C17.269 9.38969 17.6996 9.11053 18.0618 8.75786C18.4241 8.4052 18.7109 7.98605 18.9056 7.52471C19.1003 7.06337 19.1989 6.56901 19.1959 6.07028V5.82155C19.1815 4.82036 18.7665 3.8641 18.0391 3.15607C17.3118 2.44805 16.3294 2.04409 15.3009 2.03008H15.2976Z",
  fill: "#2D2D2D"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8711 2.03003L24.8094 4.33675L25.49 5.83404L27.2152 2.03003H25.8711Z",
  fill: "#2D2D2D"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M29.2735 2.03003L26.5263 8.18381L25.5071 5.82311L24.8537 4.33012L23.8509 2.03003H22.5148L24.171 5.82311L23.1518 8.18381L20.4176 2.03003H19.0815L22.5181 9.86182H23.7202L24.808 7.37032L25.8893 9.85544H27.0979L30.5377 2.03003H29.2735Z",
  fill: "#2D2D2D"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4918 6.40813C32.91 6.42429 32.3346 6.53265 31.7875 6.72911L33.1127 3.72799L34.25 6.41776L33.4918 6.40813ZM32.5554 2.03003L29.6036 8.78335C29.5421 8.90853 29.4773 9.10432 29.4157 9.21987L29.163 9.86182H30.4882L30.8673 9.04976C31.1482 8.58647 31.5467 8.20406 32.023 7.94054C32.4993 7.67702 33.037 7.54155 33.5825 7.54759H34.8462L35.8571 9.86182H37.1823L33.7542 2.03003H32.5554Z",
  fill: "#2D2D2D"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3114 6.4932H39.3026V3.32221H41.3276C41.7616 3.32959 42.1758 3.50237 42.4827 3.8041C42.7896 4.10584 42.9654 4.51295 42.9729 4.93961C42.9619 5.36213 42.7807 5.76306 42.4691 6.05436C42.1576 6.34565 41.7412 6.50349 41.3114 6.4932ZM44.1704 4.93961C44.1717 4.57185 44.0989 4.20747 43.9564 3.86746C43.8138 3.52746 43.6042 3.21853 43.3397 2.95848C43.0751 2.69844 42.7609 2.49241 42.415 2.35225C42.0691 2.2121 41.6985 2.1406 41.3244 2.14186H38.0986V9.97364H39.3026V7.79797H41.0745C41.201 7.983 42.0221 9.29095 42.5283 9.97364H43.9822C43.9173 9.91303 43.8556 9.84922 43.8556 9.78861L42.4018 7.55552C42.912 7.32051 43.3467 6.95228 43.6586 6.49098C43.9705 6.02968 44.1475 5.49304 44.1704 4.93961Z",
  fill: "#2D2D2D"
});

var _ref24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_584_32340",
  x1: 86.1428,
  y1: 3.20876,
  x2: 88.2236,
  y2: 3.20876,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDFFF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#FCF7DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#F8E3A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3C34E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1B932"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_584_32340",
  x1: 85.0112,
  y1: 6.43822,
  x2: 85.0112,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#5F3618"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#DCA24E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#E5C466"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#EBDC77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#EDE57D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_584_32340",
  x1: 82.7051,
  y1: 5.46502,
  x2: 83.2437,
  y2: 3.61569,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDE579"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#EBD672"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#E6B964"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#E2B561"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#D8A959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#C6954B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#AD7937"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A57031"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_584_32340",
  x1: 83.3599,
  y1: 7.3496,
  x2: 82.1841,
  y2: 3.60079,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#B9873C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_584_32340",
  x1: 84.5595,
  y1: 9.81297,
  x2: 82.8,
  y2: 7.40441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_584_32340",
  x1: 86.6846,
  y1: 8.48805,
  x2: 81.4457,
  y2: 10.1199,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_584_32340",
  x1: 281.834,
  y1: 41.3455,
  x2: 278.104,
  y2: 47.4002,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_584_32340",
  x1: 87.7711,
  y1: 6.3144,
  x2: 88.9313,
  y2: 14.5432,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#AA7534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#DCA24E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_584_32340",
  x1: 89.4222,
  y1: 5.30014,
  x2: 90.159,
  y2: 7.29148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_584_32340",
  x1: 92.0459,
  y1: 6.35519,
  x2: 87.0819,
  y2: 4.25816,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEAC1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#EFB534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#F3CD6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F9F3C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBFFE1"
})));

function SvgVipPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 12,
    viewBox: "0 0 93 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipPoints);
export default __webpack_public_path__ + "static/media/vip-points.7a0fb56c.svg";
export { ForwardRef as ReactComponent };